// extracted by mini-css-extract-plugin
export default {"c_panel":"Panel_c_panel__nKt+h","c_panelInner":"Panel_c_panelInner__lRwvA"};